import { createContext } from "react";
import type { FilteredWorkoutsContextType } from "../FilteredWorkoutsProvider.types";

const FilteredWorkoutsContext = createContext<FilteredWorkoutsContextType | undefined>(undefined);
FilteredWorkoutsContext.displayName = "FilteredWorkoutsContext";

export default FilteredWorkoutsContext;
